import { Injectable } from '@angular/core';
import { VariationsResponse } from '../interfaces/VariationResponse';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagsService {

  ffDeafults = new Map();
  constructor() {
    this.ffDeafults.set('long_short_funnel_ff', 'short_funnel_version');

  }

  findVariationByFeatureFlagName(variation: string): VariationsResponse | undefined {
    try {
      let varString = localStorage.getItem('variationList');
      if (varString) {
        let featuresFlags: Array<VariationsResponse> = JSON.parse(varString);
        if (featuresFlags && featuresFlags.length > 0) {
          return featuresFlags.find(f => f.featureFlagName == variation);
        }
      }
    } catch (e) {
      return undefined;
    }
    return undefined;
  }

  public isFFEqual(featureFlagName: string, variationName: string) {
    let deafultffVariation = this.ffDeafults.get(featureFlagName);
    let variationReaponse = this.findVariationByFeatureFlagName(featureFlagName);
    if ((variationReaponse != null && variationReaponse.variationName === variationName) || (variationReaponse == null && deafultffVariation === variationName)) {
      return true;
    } else {
      return false;
    }
  }


  public getFFVariant(featureFlagName: string) {
    let variation = this.ffDeafults.get(featureFlagName);
    let variationReaponse = this.findVariationByFeatureFlagName(featureFlagName);
    if ((variationReaponse != null && variationReaponse.variationName != null)) {
      variation = variationReaponse.variationName;
    }
    return variation;
  }
}
